import * as Sentry from "@sentry/nextjs";

export const logAndCaptureInSentry = (e: unknown, operationName?: string) => {
  console.error(e);
  Sentry.captureException(e, { tags: { operationName } });
  return;
};

export const logUnknownErrorCode = (code: string, operationName: string) => {
  const errorMsg = `WARNING: Unknown error code "${code}" from GraphQL operation
    ${operationName}. All new error codes must be mapped to the frontend. Please
    report to backend team for triage.`;

  console.warn(errorMsg);
  Sentry.captureMessage(errorMsg);
};

export const logWithMessageInSentry = (msg: string) => {
  console.error(msg);
  Sentry.captureMessage(msg);
};
